import React, { ReactElement, useEffect, useState } from "react";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { offlineStrings } from "./offlineStrings";
import { connectionStatus } from "../../../utils/connectionStatus";
import { StatusCard, StatusCardButton } from "../StatusCard";
import StandalonePage from "../StandalonePage";

const strings = offlineStrings;

const reloadPage = () => window.location.reload();

export type OfflineScreenProps = {
  onConnectionBack?: () => void;
};

/**
 * Offline design C: shows when the dashboard cannot load because there is no
 * internet. Nothing was typed yet, so the page reloads by itself when the
 * connection is back.
 */
const OfflineScreen = ({
  onConnectionBack = reloadPage,
}: OfflineScreenProps): ReactElement => {
  const [isChecking, setIsChecking] = useState(false);

  useEffect(
    () =>
      connectionStatus.subscribe(() => {
        if (!connectionStatus.isOffline()) {
          onConnectionBack();
        }
      }),
    [onConnectionBack]
  );

  const handleTryAgain = async () => {
    setIsChecking(true);
    try {
      await connectionStatus.checkConnection();
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <StandalonePage>
      <StatusCard
        isAlert
        tone="gold"
        icon={<WifiOffIcon />}
        eyebrow={strings.screenEyebrow}
        title={strings.screenTitle}
        description={strings.screenDescription}
        hint={strings.screenHint}
        actions={
          <StatusCardButton onClick={handleTryAgain} disabled={isChecking}>
            {strings.tryAgainButtonText}
          </StatusCardButton>
        }
      />
    </StandalonePage>
  );
};

export default OfflineScreen;
